import { setErrorsHandler } from '@/api/axios/adapter';
import administratorPage from '@/api/administrator-page/index';
import adminRelation from '@/api/admin-relation';
import attachment from '@/api/attachment';
import avatar from '@/api/avatar';
import briefcase from '@/api/briefcase';
import briefcaseIndex from '@/api/briefcase-index';
import briefcaseProjectIndex from '@/api/briefcase-project-index';
import briefcaseQuality from '@/api/briefcase-quality';
import briefcaseUdc from '@/api/briefcase-udc';
import captcha from '@/api/captcha';
import checkpointCompetenceSet from '@/api/checkpoint-competence-set';
import checkpointQuality from '@/api/checkpoint-quality';
import competence from '@/api/competence';
import documentApproval from '@/api/documet-approval';
import education from '@/api/education';
import educationProgram from '@/api/education-program';
import errorGenerator from '@/api/error-generator/index';
import expertiseType from '@/api/expertise-type';
import fingerprint from '@/api/fingerprint';
import leaderPage from '@/api/leader-page/index';
import me from '@/api/me/index';
import organisationalUnit from '@/api/organisational-unit/index';
import partnerProject from '@/api/partner-project';
import password from '@/api/password/index';
import performerPage from '@/api/performer-page';
import person from '@/api/person';
import personPublic from '@/api/person-public';
import profileInformation from '@/api/profile-information';
import profilePage from '@/api/profile-page/index';
import project from '@/api/project';
import projectCompetenceSet from '@/api/project-competence-set';
import projectExecutor from '@/api/project-executor';
import projectExecutorQuality from '@/api/project-executor-quality';
import projectManagementPage from '@/api/project-management-page/index';
import projectReport from '@/api/project-report';
import projectTask from "@/api/project-task";
import projectTaskRole from '@/api/project-task-role';
import projectTaskTarget from '@/api/project-task-target';
import projectTeamRequest from '@/api/project-team-request';
import projectType from '@/api/project-type';
import projectUdc from '@/api/project-udc';
import publication from '@/api/publication';
import publicEmailRequest from '@/api/public-email-request';
import publicProject from '@/api/public-project';
import quality from '@/api/quality';
import request from '@/api/request';
import requestType from '@/api/request-type';
import search from '@/api/search';
import setting from '@/api/setting';
import showcase from '@/api/showcase';
import signIn from '@/api/sign-in/index';
import signOut from '@/api/sign-out/index';
import signUp from '@/api/sign-up/index';
import support from '@/api/support';
import udc from '@/api/udc';
import udcUser from '@/api/udcUser';
import user from '@/api/user/index';
import volunteeringCheckpoint from '@/api/volunteering-checkpoint';
import volunteeringPeriod from '@/api/volunteering-period';

const controllers = {
  administratorPage,
  adminRelation,
  attachment,
  avatar,
  briefcase,
  briefcaseIndex,
  briefcaseProjectIndex,
  briefcaseQuality,
  briefcaseUdc,
  captcha,
  checkpointCompetenceSet,
  checkpointQuality,
  competence,
  documentApproval,
  education,
  educationProgram,
  expertiseType,
  fingerprint,
  leaderPage,
  me,
  organisationalUnit,
  partnerProject,
  password,
  performerPage,
  person,
  personPublic,
  profileInformation,
  profilePage,
  project,
  projectCompetenceSet,
  projectExecutor,
  projectExecutorQuality,
  projectManagementPage,
  projectReport,
  projectTask,
  projectTaskRole,
  projectTaskTarget,
  projectTeamRequest,
  projectType,
  projectUdc,
  publication,
  publicEmailRequest,
  publicProject,
  quality,
  request,
  requestType,
  errorGenerator,
  search,
  setting,
  showcase,
  signIn,
  signOut,
  signUp,
  support,
  udc,
  udcUser,
  user,
  volunteeringCheckpoint,
  volunteeringPeriod
};

const backend = (app, options) => {
  app.config.globalProperties['$' + options.name] = controllers;
  app.provide(options.name, controllers);
  setErrorsHandler(options.errorHandler);
};

export default backend;
